/* Chula — bespoke-surface analytics bridge
 *
 * Extracted from snippets/chula-analytics.liquid on 2026-09-20.
 *
 * It was an inline <script>: re-sent and re-parsed on every page, never
 * cached. As an asset it is fetched once, cached for the session, and
 * `defer` keeps it off the parser's critical path. Deferred scripts run
 * BEFORE DOMContentLoaded, so any global defined here still exists by the
 * time the handlers and DOMContentLoaded callers that use it run.
 */

(function () {
    if (window.chulaTrack) return;

    /* The API is resolved on EVERY call, never cached at bind time.
      web-pixels-manager loads async, so Shopify.analytics.publish is routinely
      undefined while a section's inline script is still parsing — a bind-time
      `typeof === 'function'` guard would latch false and silently no-op for
      the whole session. Same shape as the PayPal `Buttons` trap in CLAUDE.md.
      Anything published before it lands is buffered and flushed on the first
      successful call. */
    var buffer = [];
    var MAX_BUFFER = 20;

    function api() {
      return window.Shopify &&
             window.Shopify.analytics &&
             typeof window.Shopify.analytics.publish === 'function'
             ? window.Shopify.analytics.publish
             : null;
    }

    function flush(publish) {
      while (buffer.length) {
        var q = buffer.shift();
        try { publish(q[0], q[1]); } catch (e) {}
      }
    }

    window.chulaTrack = function (name, payload) {
      var publish = api();
      if (!publish) {
        // Drop the oldest rather than grow without bound if the pixel never
        // arrives (blocked by an extension, or the shop has no pixels at all).
        if (buffer.length >= MAX_BUFFER) buffer.shift();
        buffer.push([name, payload || {}]);
        return;
      }
      if (buffer.length) flush(publish);
      try { publish(name, payload || {}); } catch (e) {}
    };

    /* Forward the theme's existing event bus. */
    function forward(domEvent, pixelName, pick) {
      document.addEventListener(domEvent, function (e) {
        var d = (e && e.detail) || {};
        window.chulaTrack(pixelName, pick ? pick(d) : {});
      });
    }

    forward('chula:panel-opened', 'chula_panel_opened', function (d) {
      return { panel: d.panel || '' };
    });

    /* size-recommended is dispatched with `{ size: null }` too — that is the
      beyond-range case, where the range is the fault and not her body. It is
      worth measuring as its own outcome, so it is forwarded rather than
      dropped, flagged instead of sent as an empty string. */
    forward('chula:size-recommended', 'chula_size_recommended', function (d) {
      return d.size ? { size: d.size, beyond_range: false }
                    : { size: '', beyond_range: true };
    });

    /* Carries `available` — a pick on a sold-out size is a real signal. */
    forward('chula:size-chosen', 'chula_size_chosen', function (d) {
      return { size: d.size || '', available: d.available !== false };
    });

    /* Detail is `{ items: [...] }`, not an action/handle pair. */
    forward('chula:wishlist-change', 'chula_wishlist_change', function (d) {
      return { count: (d.items && d.items.length) || 0 };
    });

    /* Delegated, so neither the Find Your Size panel nor the Made to Measure
      cards need to know this file exists. The MTM route contract is the one
      documented in CLAUDE.md: cards are anchors carrying data-mtm-route, and
      the form listens for them on `document` — this listens the same way. */
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;

      var atc = t.closest('[data-fys-add-to-bag]');
      if (atc) {
        var sizeEl = document.querySelector('[data-fys-result-size]');
        window.chulaTrack('chula_fys_add_to_cart', {
          size: sizeEl ? (sizeEl.textContent || '').trim() : ''
        });
        return;
      }

      var route = t.closest('[data-mtm-route]');
      if (route) {
        window.chulaTrack('chula_mtm_route', {
          route: route.getAttribute('data-mtm-route') || ''
        });
      }
    }, true);

    /* Made to Measure submission is a native Shopify contact-form POST, so the page
      navigates away — an event published from a submit handler may never reach
      the pixel worker. Detect the SUCCESS RENDER instead, which is the only
      reliable side of that round trip. */
    function mtmSent() {
      if (document.querySelector('[data-mtm-sent]')) {
        window.chulaTrack('chula_mtm_submitted', {});
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mtmSent);
    } else {
      mtmSent();
    }
  })();
